<div *ngIf="!isHandset else mobileTemplate">
  <div class="filterBox" [@filterSlideIn]="show" libDraggable [dragHandle]="'.dragHandle'" [dragTarget]="'.filterBox'" [accompanyingTranslationDuration]="275">
    <h4 class="dragHandle"><i class="far fa-grip-vertical me-1" matTooltip="You can drag me"></i> Filter by Dates</h4>
    <div class="close" (click)="closeFilterBox(false)" matTooltip="Close"> &times; </div>
    <div class="filterListSection">
      
      <div class="filterList slide-fade">
        <div *ngFor="let f of activeDateFilters; let i = index" class="dateFilter row show slide-fade">
          <div class="col-2" *ngIf="f.year; else anyText">{{ f.year > 0 ? f.year : 'Unknown' }}</div>
          <div class="col-2 ms-1" *ngIf="f.month; else anyText">{{ f.month > 0 ? months[f.month - 1].txt : 'Unknown' }}</div>
          <div class="col-2 ms-1" *ngIf="f.day; else anyText">{{ f.day > 0 ? ordinalSuffix(f.day) : 'Unknown' }}</div>
          <div class="col-2 ms-1" *ngIf="showQuarters">
            <div *ngIf="showQuarters"><span *ngIf="f.quarter; else anyText">{{ f.quarter > 0 ? (ordinalSuffix(f.quarter) + ' qtr.') : 'Unknown' }}</span></div>
          </div>
          <ng-template #anyText>
            <div class="col-2 ms-1" matTooltip="Any">
              &#42;
            </div>
          </ng-template>
          <div class="col-2 ms-3">
            <button class="btn btn-link btn-lg deleteButton" matTooltip="Remove this date from filter selection" (click)="removeFromFilterList(i)">
              <i class="fal fa-times" style="vertical-align: top;"></i>
            </button>
          </div>
        </div>      
      </div>

      <div class="row">
        <div class="col-3">
          <mat-form-field style="width: 160px;">
            <mat-label>{{ chosenYear > 0 ? 'Year' : 'Any Year' }}</mat-label>
            <mat-select #yearDropdown disableRipple [typeaheadDebounceInterval]="dropdownTypeDebounceTime" (selectionChange)="changeYear($event)">
              <mat-option>Any</mat-option>
              <mat-option value="0">Unknown</mat-option>
              <mat-divider></mat-divider>
              <mat-option *ngFor="let fy of listOfFocusedYears" [value]="fy">
                <strong>{{ fy }}</strong>
              </mat-option>
              <mat-divider></mat-divider>
              <mat-option *ngFor="let y of listOfYears" [value]="y">
                {{ y }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>        
        <div class="col-3 ms-1">
          <mat-form-field style="width: 170px;">
            <mat-label>{{ chosenMonth > 0 ? 'Month' : 'Any Month' }}</mat-label>
            <mat-select #monthDropdown disableRipple [typeaheadDebounceInterval]="dropdownTypeDebounceTime" (selectionChange)="changeMonth($event)" [value]="chosenMonth">
              <mat-option>Any</mat-option>
              <mat-option value="0">Unknown</mat-option>
              <mat-divider></mat-divider>
              <mat-option *ngFor="let m of months" [disabled]="!m['selected']" [ngClass]="{'disabled': !m['selected']}" [value]="m.val">
                {{ m.txt }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>        
        <div class="col-3 ms-1">
          <mat-form-field style="width: 150px;">
            <mat-label>{{ chosenDate > 0 ? 'Day' : 'Any Day' }}</mat-label>
            <mat-select #dateDropdown [typeaheadDebounceInterval]="dropdownTypeDebounceTime" disableRipple (selectionChange)="changeDate($event)" [value]="chosenDate">
              <mat-option>Any</mat-option>
              <mat-option value="0">Unknown</mat-option>
              <mat-divider></mat-divider>
              <mat-option *ngFor="let d of dates" [hidden]="!d[1]" [disabled]="!d[1]" [ngClass]="{'disabled': !d[1]}" [value]="d[0]">
                {{ d[0] }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>        
        <div class="col-3 ms-1" *ngIf="showQuarters">
          <mat-form-field style="width: 180px;">
            <mat-label>{{ chosenQuarter > 0 ? 'Quarter' : 'Any Quarter' }}</mat-label>
            <mat-select #qtrDropdown [typeaheadDebounceInterval]="dropdownTypeDebounceTime" disableRipple (selectionChange)="changeQtr($event)">
              <mat-option>Any</mat-option>
              <mat-option value="0"> Unknown </mat-option>
              <mat-divider></mat-divider>
              <mat-option value="1"> 1st </mat-option>
              <mat-option value="2"> 2nd </mat-option>
              <mat-option value="3"> 3rd </mat-option>
              <mat-option value="4"> 4th </mat-option>
            </mat-select>
          </mat-form-field>
        </div>        
        <div class="col-2 ms-3">
          <button class="btn btn-secondary" type="button" style="margin-top: 8px;" id="addDateFilterButton" matTooltip="Add and apply date filter" (click)="addToFilterList()">
            Add <i class="fal fa-plus-hexagon ms-1"></i>
          </button>
        </div>
      </div>
    </div>
    <hr>
    <app-slant-button btnColor="blue" [linkMode]="true" id="applyButton" tooltip="Dismiss this box" (click)="closeFilterBox(false)" btnIconClass="">Close</app-slant-button>
    <app-slant-button btnColor="gray" [linkMode]="true" id="cancelButton" tooltip="Clear all date filters and close this box" [disabled]="activeDateFilters.length < 1" (click)="closeFilterBox(true)" btnIconClass="fa-ban">Clear Date Filters</app-slant-button>
    <span style="float: right; padding: .5em .5em 0 0;">
      <label class="text-muted" *ngIf="activeDateFilters.length">
        {{ activeDateFilters.length }} date filter(s) applied
      </label>
    </span>
  </div>
</div>

<ng-template #mobileTemplate>
    <div class="filterBox mobile" [@filterSlideIn]="show" libDraggable [dragHandle]="'.dragHandle'" [dragTarget]="'.filterBox'" [accompanyingTranslationDuration]="275">
    <h4 class="dragHandle"><i class="far fa-grip-vertical me-1" matTooltip="You can drag me"></i> Filter by Dates</h4>
    <div class="close" (click)="closeFilterBox(false)" matTooltip="Close"> &times; </div>
    <div class="filterListSection mobile">
      
      <div class="filterList slide-fade">
        <div *ngFor="let f of activeDateFilters; let i = index" class="dateFilter row show slide-fade">
          <div class="col-2" *ngIf="f.year; else anyText">{{ f.year > 0 ? f.year : 'Unknown' }}</div>
          <div class="col-1"></div>
          <div class="col-2 ms-1" *ngIf="f.month; else anyText">{{ f.month > 0 ? months[f.month - 1].txt : 'Unknown' }}</div>
          <div class="col-1"></div>
          <div class="col-2 ms-1" *ngIf="f.day; else anyText">{{ f.day > 0 ? ordinalSuffix(f.day) : 'Unknown' }}</div>

          <ng-template #anyText>
            <div class="col-2 ms-1" matTooltip="Any">
              &#42;
            </div>
          </ng-template>
          <div class="col-2 ms-3">
            <button class="btn btn-link btn-lg deleteButton" matTooltip="Remove this date from filter selection" (click)="removeFromFilterList(i)">
              <i class="fal fa-times" style="vertical-align: top;"></i>
            </button>
          </div>
        </div>
      </div>
  
      <div class="row">
        <div class="col-3">
          <mat-form-field style="width: 110px;">
            <mat-label>{{ chosenYear > 0 ? 'Year' : 'Any Year' }}</mat-label>
            <mat-select #yearDropdown disableRipple [typeaheadDebounceInterval]="dropdownTypeDebounceTime" (selectionChange)="changeYear($event)">
              <mat-option>Any</mat-option>
              <mat-option value="0">Unknown</mat-option>
              <mat-divider></mat-divider>
              <mat-option *ngFor="let fy of listOfFocusedYears" [value]="fy">
                <strong>{{ fy }}</strong>
              </mat-option>
              <mat-divider></mat-divider>
              <mat-option *ngFor="let y of listOfYears" [value]="y">
                {{ y }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-1 ms-1"></div>
  
        <div class="col-3 ms-1">
          <mat-form-field style="width: 115px;">
            <mat-label>{{ chosenMonth > 0 ? 'Month' : 'Any Month' }}</mat-label>
            <mat-select #monthDropdown disableRipple [typeaheadDebounceInterval]="dropdownTypeDebounceTime" (selectionChange)="changeMonth($event)" [value]="chosenMonth">
              <mat-option>Any</mat-option>
              <mat-option value="0">Unknown</mat-option>
              <mat-divider></mat-divider>
              <mat-option *ngFor="let m of months" [disabled]="!m['selected']" [ngClass]="{'disabled': !m['selected']}" [value]="m.val">
                 {{ m.txt }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-1 ms-1"></div>
  
        <div class="col-3 ms-1">
          <mat-form-field style="width: 105px;">
            <mat-label>{{ chosenDate > 0 ? 'Day' : 'Any Day' }}</mat-label>
            <mat-select #dateDropdown [typeaheadDebounceInterval]="dropdownTypeDebounceTime" disableRipple (selectionChange)="changeDate($event)" [value]="chosenDate">
              <mat-option>Any</mat-option>
              <mat-option value="0">Unknown</mat-option>
              <mat-divider></mat-divider>
              <mat-option *ngFor="let d of dates" [hidden]="!d[1]" [disabled]="!d[1]" [ngClass]="{'disabled': !d[1]}" [value]="d[0]">
                 {{ d[0] }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
  

      </div>
    </div>

    <hr>

    <div class="row">

      <div class="col-3">
        <button class="btn btn-secondary" type="button" style="vertical-align: text-top;" id="addDateFilterButton" matTooltip="Add and apply date filter" (click)="addToFilterList()">
          Add <i class="fal fa-plus-hexagon ms-1"></i>
        </button>
      </div>
    
      <div class="col-3">
        <app-slant-button btnColor="blue" [linkMode]="true" id="applyButton" tooltip="Dismiss this box" (click)="closeFilterBox(false)" btnIconClass="">Close</app-slant-button>
      </div>

      <div class="col-6">
        <app-slant-button btnColor="gray" [linkMode]="true" id="cancelButton" tooltip="Clear all date filters and close this box" [disabled]="activeDateFilters.length < 1" (click)="closeFilterBox(true)" btnIconClass="fa-ban">Clear Date Filters</app-slant-button>
      </div>
    
    </div>

    <span style="float: right; padding: .5em .5em 0 0;">
      <label class="text-muted" *ngIf="activeDateFilters.length">
        {{ activeDateFilters.length }} date filter(s) applied
      </label>
    </span>

  </div>

</ng-template>
